import { render, staticRenderFns } from "./NewEditClientView.vue?vue&type=template&id=3b77a5c6&scoped=true"
import script from "./NewEditClientView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewEditClientView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewEditClientView.vue?vue&type=style&index=0&id=3b77a5c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b77a5c6",
  null
  
)

export default component.exports